
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { EstruturaConfig, nomesEstrutura } from "@/types";
import { Construction } from "lucide-react";

interface EstruturasListProps {
  fields: any[];
  form: any;
}

export const EstruturasList = ({ fields, form }: EstruturasListProps) => {
  return (
    <div className="space-y-4 mt-6">
      <h3 className="text-lg font-semibold flex items-center gap-2">
        <Construction className="h-5 w-5" /> Configuração de Estruturas
      </h3>
      <p className="text-sm text-muted-foreground">
        Configure o valor por kWp para cada tipo de estrutura.
      </p>
      
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Tipo de Estrutura</TableHead>
            <TableHead>Valor por kWp (R$)</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {fields.map((field, index) => (
            <TableRow key={field.id}>
              <TableCell>
                {nomesEstrutura[field.tipo] || field.tipo}
              </TableCell>
              <TableCell>
                <FormField
                  control={form.control}
                  name={`estruturas.${index}.valorPorKwp`}
                  render={({ field: inputField }) => (
                    <FormItem>
                      <FormControl>
                        <Input type="number" step="0.01" min="0" {...inputField} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
